import React from "react";
import { HiddenText } from "./VisuallyHidden.styles";
import type { VisuallyHiddenProps } from "./VisuallyHidden.types";

/** Screen-reader-only text, e.g. "(opens in a new tab)" or a polite live region. */
export const VisuallyHidden: React.FC<VisuallyHiddenProps> = ({
  children,
  ...rest
}) => <HiddenText {...rest}>{children}</HiddenText>;

export default VisuallyHidden;
